const Tabs = () => {
  const tabsSections = [...document.querySelectorAll(".tabs__section")];

  if (tabsSections.length > 0) {
    tabsSections.forEach((tabsSection) => {
      const tabsTitles = [...tabsSection.querySelectorAll(".tabs__item")];
      const tabsMains = [...tabsSection.querySelectorAll(".tabs__main")];
  
      if (tabsTitles.length > 0 && tabsMains.length > 0) {
        tabsTitles[0].classList.add("active");
        tabsMains[0].classList.add("active");

        tabsTitles.forEach((tabsTitle, index) => {
          tabsTitle.addEventListener("click", () => {
            tabsTitles.forEach((title, i) => {
              if (i !== index && tabsMains[i]) {
                title.classList.remove("active");
                tabsMains[i].classList.remove("active");
              }
            });

            tabsTitle.classList.add("active");
            if (tabsMains[index]) {
              tabsMains[index].classList.add("active");
            }
          });
        });
      }
    })
  }
}

export default Tabs


